// Where the application wizard's back link goes. The page that opens the
// wizard passes the place it is on in router state, so the link returns
// there; a direct visit has no such state and returns to Request Support.
const LABELS = {
    '/courses': 'Courses',
    '/applications': 'Support requests',
    '/applications/start': 'Request Support',
    '/dashboard': 'Dashboard',
};

export const FALLBACK_BACK_LINK = {
    to: '/applications/start',
    label: 'Request Support',
};

export function cameFromState(location) {
    return { from: `${location.pathname}${location.search}` };
}

export function backLinkFor(state) {
    const from = state?.from;
    if (typeof from !== 'string') return FALLBACK_BACK_LINK;
    const label = LABELS[from.split('?')[0]];
    return label ? { to: from, label } : FALLBACK_BACK_LINK;
}
